import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Monthly from "./pages/Monthly/Monthly.tsx";
import Breadcrumb from "./components/Breadcrumb/Breadcrumb.tsx";
import Header from "./components/Header/Header.tsx";
import AuthProvider from "./context/AuthContext.tsx";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.tsx";
import Login from "./pages/Login/Login.tsx";
import Account from "./pages/Account/Account.tsx";
import Footer from "./views/Footer/Footer.tsx";
import About from "./pages/About/About.tsx";
import Contact from "./pages/Contact/Contact.tsx";
import Privacy from "./pages/Privacy/Privacy.tsx";
import Onboarding from "./pages/Onboarding/Onboarding.tsx";
import CashFlow from "./pages/CashFlow/CashFlow.tsx";
import Income from "./pages/Income/Income.tsx";
import OwnerPay from "./pages/OwnerPay/OwnerPay.tsx";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <>
          <Header />
          <Breadcrumb />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/onboarding"
              element={<PrivateRoute component={Onboarding} />}
            />
            <Route
              path="/cash-flow"
              element={<PrivateRoute component={CashFlow} />}
            />
            <Route
              path="/income"
              element={<PrivateRoute component={Income} />}
            />
            <Route
              path="/owner-pay"
              element={<PrivateRoute component={OwnerPay} />}
            />
            <Route
              path="/monthly/:type/:month/:year"
              element={<PrivateRoute component={Monthly} />}
            />
            <Route
              path="/account"
              element={<PrivateRoute component={Account} />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </>
      </AuthProvider>
    </Router>
  );
};

export default App;
